export type STYLE_RECORD_KEY = "appConfig" | "userConfig";

const insertedRecord: Record<STYLE_RECORD_KEY, any> = {
  appConfig: null,
  userConfig: null,
};

export const insertStyles = (
  styles: string | any,
  recordKey?: STYLE_RECORD_KEY
) => {
  let styleElt, styleSheet;
  if ((document as any).createStyleSheet) {
    // IE
    styleSheet = (document as any).createStyleSheet();
  } else {
    let head = document.getElementsByTagName("head")[0];
    styleElt = document.createElement("style");
    head.appendChild(styleElt);
    styleSheet = document.styleSheets[document.styleSheets.length - 1];
  }
  if (typeof styles === "string") {
    if (styleElt) styleElt.innerHTML = styles;
    else styleSheet.cssText = styles; // IE
  } else {
    let i = 0;
    for (let selector in styles) {
      if (styleSheet.insertRule) {
        let rule = selector + " {" + styles[selector] + "}";
        styleSheet.insertRule(rule, i++);
      } else {
        styleSheet.addRule(selector, styles[selector], i++);
      }
    }
  }

  if (recordKey) {
    insertedRecord[recordKey] = styleElt;
  }
};
